import { WithTranslation } from 'react-i18next';

export interface IOrientationOverlay extends WithTranslation {
  isButton?: boolean;
  onClick?: () => void;
  orientation: OrientationFromTo;
}

export enum OrientationFromTo {
  PORTRAIT_TO_LANDSCAPE = 'portraitToLandscape',
  LANDSCAPE_TO_PORTRAIT = 'landscapeToPortrait',
}
